(ns frontend.view.modals.curtains.filter-curtain.events
  (:require [frontend.logging :as logging]
            [clojure.string :as string]))

(def multi-value-operands [:operand/between-exclusive :operand/between-inclusive :operand/between :operand/between-exclusive-date :operand/between-inclusive-date])

(def bool-value-operands [:operand/true :operand/false :operand/known :operand/unknown])

(defn bool-value-operand? [operand]
  (some #{operand} bool-value-operands))

(defn valid-operand-state? [operand v]
  (cond (some #{operand} bool-value-operands)
        true
        (some #{operand} multi-value-operands)
        (and (:upper-bound-value v)
             (:lower-bound-value v))
        :else
        (or (:upper-bound-value v)
            (:lower-bound-value v))))

(defn set-operand [filter-state v]
  (if-not v
    (swap! filter-state dissoc :operand)
    (swap! filter-state assoc :operand v)))

(defn set-field-key [value-state v]
  (let [v (cond (string? v) (keyword v)
                (number? v) v
                (sequential? v) (->> v
                                     (map (fn [vs]
                                            (cond (string? vs) (keyword vs)
                                                  (number? vs) vs
                                                  (keyword? vs) vs
                                                  :else
                                                  nil)))
                                     (remove nil?)
                                     (vec))
                (keyword? v) v
                :else
                nil)]
    (reset! value-state v)
    (deref value-state)))

(defn set-lower-bound-value [filter-state v]
  (if (nil? v)
    (swap! filter-state dissoc :lower-bound-value)
    (swap! filter-state assoc :lower-bound-value v)))

(defn set-upper-bound-value [filter-state v]
  (if (or (nil? v) (and (or (coll? v)
                            (sequential? v)
                            (list? v)
                            (string? v))
                        (empty? v)))
    (swap! filter-state dissoc :upper-bound-value)
    (swap! filter-state assoc :upper-bound-value v)))

(defn set-bound-value [filter-state value-key v]
  (case value-key
    :lower-bound-value (set-lower-bound-value filter-state v)
    :upper-bound-value (set-upper-bound-value filter-state v)
    (logging/error "Uknown filter bound key : " value-key " -> " v)))

(defn cleanup-local-state! [filter-state]
  (let [{:keys [operand]} @filter-state]
    (when-not (some #{operand} multi-value-operands)
      (swap! filter-state dissoc :upper-bound-value))
    (when (bool-value-operand? operand)                     ;; by adding upper-bound value we can ensure known / unkonwn operands are saved
      ;; - save function does not save anything if both lower and upper bound values are empty
      (swap! filter-state dissoc :lower-bound-value)
      (swap! filter-state assoc :upper-bound-value :set))))

(defn kw-identifier [filter-keyword-or-path]
  (if (keyword? filter-keyword-or-path)
    (name filter-keyword-or-path)
    (->> filter-keyword-or-path
         (map (fn [k]
                (cond (keyword? k)
                      (name k)
                      (sequential? k)
                      (->> k
                           (map kw-identifier)
                           (string/join "__"))
                      :else
                      (do (logging/warn "Unexpected filter path type " k " << " (type k))
                          (str k)))))
         (string/join "_OR_"))))

(defn resolve-or-key [filter-state]
  (keyword "or" (->> @filter-state
                     :filter/child-filters
                     (map (fn [[k _]]
                            k))
                     (kw-identifier))))

(defn merge-filters [main-filter child-filter]
  (let [[main-filter-kw main-filter-config] main-filter]
    [:or/filter
     (if (= :filter.type/or-combination (:filter/type main-filter-config))
       (assoc main-filter-config
         :lower-bound-value (inc (count (:filter/child-filters main-filter-config)))
         :filter/child-filters (conj (:filter/child-filters main-filter-config)
                                     child-filter))
       {:filter/type          :filter.type/or-combination
        :lower-bound-value    2
        :filter/child-filters [main-filter child-filter]})]))

(defn valid-state? [key-state filter-state]
  (let [data @filter-state
        filter-key @key-state]
    (and filter-key
         data
         (seq data)
         (if (or (not (keyword? filter-key))
                 (not= "or" (namespace filter-key)))
           (and (:operand data)
                (valid-operand-state? (:operand data) data))
           (let [child-filters (:filter/child-filters data)]
             (and (> (count child-filters) 0)
                  (->> child-filters
                       (remove (fn [[k v]]
                                 (and k
                                      (:operand v)
                                      (valid-operand-state? (:operand v) v))))
                       (empty?))))))))
